import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "teaser" };
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "col-xs-12 col-sm-6" };
const _hoisted_4 = { class: "teaser__item teaser__item--login" };
const _hoisted_5 = { class: "col-xs-12 col-sm-6" };
const _hoisted_6 = {
    key: 0,
    class: "teaser__item teaser__item--request-access"
};
import { ref } from "vue";
import config from "../services/PortalConfig";
export default /*@__PURE__*/ _defineComponent({
    __name: 'HomeLoginRegisterTeaser',
    setup(__props) {
        const accessRequestsEnabled = ref(config.accessRequestsEnabled);
        return (_ctx, _cache) => {
            const _component_icon = _resolveComponent("icon");
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('login.teaser.title')), 1),
                            _cache[0] || (_cache[0] = _createTextVNode()),
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('login.teaser.text')), 1),
                            _cache[1] || (_cache[1] = _createTextVNode()),
                            _createVNode(_component_router_link, {
                                to: { name: 'login' },
                                class: "button button--outline"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_icon, { name: "login" }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('login.log-in')), 1)
                                ]),
                                _: 1
                            })
                        ])
                    ]),
                    _cache[4] || (_cache[4] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_5, [
                        (accessRequestsEnabled.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createElementVNode("h3", null, _toDisplayString(_ctx.$t('login.register_teaser.title')), 1),
                                _cache[2] || (_cache[2] = _createTextVNode()),
                                _createElementVNode("p", null, _toDisplayString(_ctx.$t('login.register_teaser.text')), 1),
                                _cache[3] || (_cache[3] = _createTextVNode()),
                                _createVNode(_component_router_link, {
                                    to: { name: 'login_access' },
                                    class: "button button--outline"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_icon, { name: "user-lock" }),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('login.request-access')), 1)
                                    ]),
                                    _: 1
                                })
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]));
        };
    }
});
